import { ServicePageTemplate } from "./ServicePageTemplate";
import { getServiceBySlug } from "@/data/services";

const AromatherapyMassage = () => (
  <ServicePageTemplate service={getServiceBySlug("aromatherapy-massage")} />
);

export default AromatherapyMassage;
